import { render, staticRenderFns } from "./ReceivedTabel.vue?vue&type=template&id=d41e6de8&scoped=true"
import script from "./ReceivedTabel.vue?vue&type=script&lang=js"
export * from "./ReceivedTabel.vue?vue&type=script&lang=js"
import style0 from "./ReceivedTabel.vue?vue&type=style&index=0&id=d41e6de8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41e6de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d41e6de8')) {
      api.createRecord('d41e6de8', component.options)
    } else {
      api.reload('d41e6de8', component.options)
    }
    module.hot.accept("./ReceivedTabel.vue?vue&type=template&id=d41e6de8&scoped=true", function () {
      api.rerender('d41e6de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/officialDocProcess/components/ReceivedTabel.vue"
export default component.exports